import { Controller } from "@hotwired/stimulus"
import { visit } from "@hotwired/turbo"

export default class extends Controller {
  static values = {
    frame: String
  }
  visit(event) {
    let url = event.target.value;

    if (event.target.dataset.url && event.target.dataset.param) {
      const baseUrl = event.target.dataset.url;
      const param = event.target.dataset.param;
      const value = event.target.value;
      const separator = baseUrl.includes('?') ? '&' : '?';

      url = `${baseUrl}${separator}${param}=${value}`;
    }

    if (url) {
      visit(url, { frame: this.frameValue  });
    }
  }
}